// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/svg/select-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gamification {
  min-height: 100vh;
  margin: 0 -1.68234375vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
  border: 2px solid;
  border-radius: 0.21vw;
  border-image: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
}
.gamification .game-list {
  display: flex;
  gap: 1.39vw;
  margin: auto;
  justify-content: space-between;
  border: 2px solid;
  border-radius: 0.21vw;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  padding: 2.22vw;
  width: 69.59vw;
}
.gamification .game-list > div {
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  border-radius: 0.21vw;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.gamification .game-list .details-container {
  width: 31.54vw;
}
.gamification .game-list .img-container {
  position: relative;
  height: 17.76vw;
  width: 100%;
}
.gamification .game-list img {
  width: 100%;
  cursor: pointer;
  height: 100%;
  height: 100%;
}
.gamification .game-list .play-icon {
  position: absolute;
  cursor: pointer;
  top: 55%;
  left: 52%;
  transform: translate(-50%, -50%);
}
.gamification .game-list img:hover + .play-icon svg,
.gamification .game-list .play-icon:hover svg {
  filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg) brightness(87%) contrast(116%);
}
.gamification .game-list .title {
  width: 18.2vw;
  position: absolute;
  font-size: 0.5649vw;
  font-weight: 400;
  line-height: 0.6118vw;
  bottom: 2%;
  text-align: center;
  right: 0%;
  border-radius: 0.21vw;
  padding: 0.555vw 1.11vw;
  background: rgba(226, 226, 226, 0.7490196078);
  border-radius: 2.02px, 0px, 0px, 2.02px;
}
.gamification .game-list .game-detail {
  padding: 2.5vw 2.22vw;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.gamification .game-list .game-detail .game-title {
  font-size: 0.91vw;
  line-height: 1.25vw;
  font-weight: 500;
  color: #0f0f0f;
}
.gamification .game-list .game-detail > div {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
.gamification .game-list .game-detail .game-description {
  font-size: 0.835vw;
  line-height: 1.25vw;
  margin-top: 0.555vw;
  font-weight: 400;
  color: #3a3a3a;
}
.gamification .game-list .game-detail .customize {
  font-size: 0.901875vw;
  font-weight: 600;
  line-height: 1.25vw;
  letter-spacing: 0em;
  text-align: center;
  border-radius: 0.21vw;
  border: none;
  transition: 0.2s ease-in-out all;
  cursor: pointer;
  color: #ffffff;
  background: #ee3a24;
  padding: 0.8325vw 2.22vw;
  width: max-content;
  margin: 0.8325vw 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gamification .game-list .game-detail .customize span {
  position: relative;
  padding: 0;
  top: 0.14vw;
  margin: 0 1.11vw;
}
.gamification .videoPopup {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
}
.gamification .videoPopup .video {
  justify-content: center;
}

.trigger_limit select, .is_active select {
  border: 1px solid #bebaba !important;
}

.trigger_limit select:focus, .is_active select:focus {
  border: 1px solid rgba(238, 58, 36, 0.8) !important;
}

.trigger_limit select, .is_active select {
  width: 100%;
  appearance: none;
}

.trigger_limit select#triggerTime,
.trigger_limit select#trigger_limit,
.is_active select#is_active,
.is_active select#is_active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-color: #fff;
}

.trigger_limit select#triggerTime,
.trigger_limit select#trigger_limit,
.is_active select#is_active,
.is_active select#is_active {
  background-size: 0.754rem;
  background-position: calc(100% - 0.555vw) 1.38vw;
  background-repeat: no-repeat;
}

.trigger_limit select,
.is_active select,
.coupon_code input,
.add-question input,
.Options input {
  width: 100%;
  font-weight: 400;
  line-height: 1.25vw;
  font-size: 0.901875vw;
  color: #616161;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border-radius: 0.21vw;
  padding: 0.8325vw 0.555vw;
}

.coupon_code .MuiFormControl-root {
  margin: 0 !important;
  border: none;
  box-shadow: none;
  border-radius: 3px;
  color: rgba(217, 217, 217, 0);
}

.coupon_code .MuiInputBase-root {
  color: rgba(217, 217, 217, 0);
  box-shadow: none;
  padding: 0.6vw 0.555vw;
}

.coupon_code .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,
.coupon_code .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {
  border: 1px solid #ababab;
}

.coupon-quiz-input {
  margin: 0.7vw 0;
  width: 100%;
  border-radius: 3px;
}

.coupon_code {
  position: relative;
}

.plus-icon {
  position: absolute;
  right: 1.3875vw;
}

.select-gamification {
  font-size: 0.91vw;
  line-height: 1.25vw;
  font-weight: 500;
  color: #616161;
  cursor: pointer;
}

.ques-subheading {
  font-size: 1.05vw !important;
  color: #ee3a24;
  font-weight: 500 !important;
  line-height: 1.25vw !important;
  margin-top: 0.15vw !important;
}

.add-ques-text {
  font-size: 1.05vw !important;
  font-weight: 500 !important;
  line-height: 1.25vw !important;
  color: #3a3a3a !important;
}

.quiz-container .MuiFormControlLabel-label {
  font-size: 0.91vw !important;
  font-weight: 400 !important;
  line-height: 1.25vw !important;
  color: #ababab !important;
}

.trigger-time, .is_active {
  font-size: 1.05vw !important;
  line-height: 1.25vw !important;
  font-weight: 500 !important;
}

.trigger_limit label,
.is_active label,
.coupon_code label {
  font-size: 1.05vw;
  font-weight: 500;
  width: 100%;
  line-height: 1.25vw;
  color: #3a3a3a;
}

.add-question label,
.Options label {
  font-size: 1.05vw;
  font-weight: 500;
  width: 30%;
  line-height: 1.25vw;
  color: #3a3a3a;
}

.Options {
  position: relative;
}

.Options input {
  position: relative;
  left: 3.13vw;
}

.correct-ans {
  width: 33%;
  margin-left: 3.82vw;
  font-size: 0.8325vw;
  font-weight: 400;
  line-height: 1.25vw;
  color: #ababab;
}

.correct-ans-box {
  width: 1.05vw;
  height: 0.7vw;
  border-radius: 50%;
  border: 1px solid #ababab;
}

.correct-ans.active {
  color: #b01f8d;
}

.correct-ans-box.active {
  width: 1.25vw;
  height: 0.7vw;
  border-radius: 50%;
  background-color: #b01f8d;
  border: none;
}

.trigger_limit {
  margin-top: 1.11vw;
}

.trigger_limit,
.is_active,
.coupon_code,
.add-question,
.Options {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.555vw 0;
}

.spin-wheel-game-container,
.quiz_coupon_code_container {
  width: 58.24vw;
  margin: auto;
}
.spin-wheel-game-container .MuiFormHelperText-root.Mui-error,
.quiz_coupon_code_container .MuiFormHelperText-root.Mui-error {
  font-size: 11px;
  margin: 0.25rem;
  color: rgba(238, 58, 36, 0.8) !important;
}

.select-gamification {
  display: flex;
  align-items: center;
}

.spin-wheel-submit {
  text-align: center;
}

.spin-wheel-submit button {
  background-color: #ee3a24;
  border-radius: 0.21vw;
  padding: 1.11vw 4.44vw;
  border: none;
  color: #fff;
  cursor: pointer;
}

.inner-quiz-game-container form {
  margin: auto;
  width: 47.94vw;
}

.inner-game-container form {
  margin: auto;
  width: 29.21vw;
}

.submit-quiz {
  text-align: center;
}

.quiz-tb-container {
  align-items: center !important;
  display: flex !important;
  justify-content: center;
}

.prev-submit-quiz {
  margin-left: 0.35vw !important;
  margin-right: 0.7vw !important;
  background-color: #fff;
  border-radius: 0.21vw !important;
  padding: 0.555vw 2.22vw !important;
  border: 1px solid #ee3a24 !important;
  color: #ee3a24 !important;
  cursor: pointer !important;
  align-items: center !important;
  display: flex !important;
}

.submit-quiz {
  margin-left: 0.35vw !important;
  margin-right: 0.7vw !important;
  background-color: #ee3a24 !important;
  border-radius: 0.21vw !important;
  padding: 0.555vw 2.22vw !important;
  border: none !important;
  color: #fff !important;
  cursor: pointer !important;
  align-items: center !important;
  display: flex !important;
}

.MuiInputBase-root.Mui-error fieldset.MuiOutlinedInput-notchedOutline {
  border: 1px solid rgba(238, 58, 36, 0.8);
}

.gamification .game-list .game-detail .customize:disabled,
.button2:disabled,
.button2[disabled] {
  background: #dcdcdc !important;
  color: #939393 !important;
  border: aliceblue;
  cursor: unset;
}

.gamification .game-list .game-detail .customize:disabled svg path,
.button2:disabled svg path,
.button2[disabled] svg path {
  fill: #939393 !important;
}`, "",{"version":3,"sources":["webpack://./src/style/components/game/Game.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,uBAAA;EACA,+DAAA;EACA,yGAAA;EAKA,iBAAA;EACA,qBAAA;EACA,sGAAA;AAHF;AASE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;EACA,6GAAA;EAKA,eAAA;EACA,cAAA;AAXJ;AAaI;EAGE,+DAAA;EACA,6GAAA;EAKA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAjBN;AAoBI;EACE,cAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAnBN;AAsBI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AApBN;AAuBI;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AArBN;AAwBI;;EAEE,gGAAA;AAtBN;AA0BI;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,6CAAA;EACA,uCAAA;AAxBN;AA2BI;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAzBN;AA2BM;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAzBR;AA2BM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;AAzBR;AA4BM;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA1BR;AA6BM;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA3BR;AA6BQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AA3BV;AAiCE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;AA/BJ;AAiCI;EACE,uBAAA;AA/BN;;AAoCA;EACE,oCAAA;AAjCF;;AAoCA;EACE,mDAAA;AAjCF;;AAoCA;EACE,WAAA;EAGA,gBAAA;AAjCF;;AAoCA;;;;EAIE,6DAAA;EACA,sBAAA;AAjCF;;AAoCA;;;;EAIE,yBAAA;EACA,gDAAA;EACA,4BAAA;AAjCF;;AAoCA;;;;;EAKE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,0BAAA;EAEA,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,yBAAA;AAjCF;;AAoCA;EACE,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;AAjCF;;AAoCA;EACE,6BAAA;EACA,gBAAA;EACA,sBAAA;AAjCF;;AAoCA;;EAEE,yBAAA;AAjCF;;AAoCA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,4BAAA;EACA,cAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AAjCF;;AAoCA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;AAjCF;;AAoCA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;AAjCF;;AAoCA;EACE,4BAAA;EACA,8BAAA;EACA,2BAAA;AAjCF;;AAoCA;;;EAGE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAjCF;;AAoCA;;EAEE,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;EACE,kBAAA;EACA,YAAA;AAjCF;;AAoCA;EACE,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAjCF;;AAoCA;EACE,cAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;;;;;EAKE,aAAA;EACA,6BAAA;EACA,mBAAA;EAEA,kBAAA;AAlCF;;AAqCA;;EAEE,cAAA;EACA,YAAA;AAlCF;AAmCE;;EACE,eAAA;EACA,eAAA;EACA,wCAAA;AAhCJ;;AAoCA;EACE,aAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,kBAAA;AAjCF;;AAoCA;EACE,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAjCF;;AAqCE;EACE,YAAA;EACA,cAAA;AAlCJ;;AAuCE;EACE,YAAA;EACA,cAAA;AApCJ;;AAwCA;EACE,kBAAA;AArCF;;AAwCA;EACE,8BAAA;EACA,wBAAA;EACA,uBAAA;AArCF;;AAwCA;EACE,8BAAA;EACA,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,kCAAA;EACA,oCAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,wBAAA;AArCF;;AAwCA;EACE,8BAAA;EACA,8BAAA;EACA,oCAAA;EACA,gCAAA;EACA,kCAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;EACA,wBAAA;AArCF;;AAuCA;EACE,wCAAA;AApCF;;AAsCA;;;EAGE,8BAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;AAnCF;;AAqCA;;;EAGE,wBAAA;AAlCF","sourcesContent":[".gamification {\n  min-height: 100vh;\n  margin: 0 -1.68234375vw;\n  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n  background: radial-gradient(\n    100% 100% at 0% 0%,\n    rgba(255, 255, 255, 0.4) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  border: 2px solid;\n  border-radius: 0.21vw;\n  border-image: linear-gradient(\n    169.15deg,\n    rgba(255, 255, 255, 0.4) 0%,\n    rgba(238, 237, 237, 0.2) 96.79%\n  );\n\n  .game-list {\n    display: flex;\n    gap: 1.39vw;\n    margin: auto;\n    justify-content: space-between;\n    border: 2px solid;\n    border-radius: 0.21vw;\n    border-image-source: linear-gradient(\n      169.15deg,\n      rgba(255, 255, 255, 0.4) 0%,\n      rgba(238, 237, 237, 0.2) 96.79%\n    );\n    padding: 2.22vw;\n    width: 69.59vw;\n\n    & > div {\n      // border: 2px solid;\n\n      box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n      border-image-source: linear-gradient(\n        169.15deg,\n        rgba(255, 255, 255, 0.4) 0%,\n        rgba(238, 237, 237, 0.2) 96.79%\n      );\n      border-radius: 0.21vw;\n      background-color: #fff;\n      display: flex;\n      flex-direction: column;\n    }\n\n    .details-container {\n      width: 31.54vw;\n    }\n\n    .img-container {\n      position: relative;\n      height: 17.76vw;\n      width: 100%;\n    }\n\n    img {\n      width: 100%;\n      cursor: pointer;\n      height: 100%;\n      height: 100%;\n    }\n\n    .play-icon {\n      position: absolute;\n      cursor: pointer;\n      top: 55%;\n      left: 52%;\n      transform: translate(-50%, -50%);\n    }\n\n    img:hover + .play-icon svg,\n    .play-icon:hover svg {\n      filter: invert(54%) sepia(94%) saturate(4765%) hue-rotate(339deg)\n        brightness(87%) contrast(116%);\n    }\n\n    .title {\n      width: 18.2vw;\n      position: absolute;\n      font-size: 0.5649vw;\n      font-weight: 400;\n      line-height: 0.6118vw;\n      bottom: 2%;\n      text-align: center;\n      right: 0%;\n      border-radius: 0.21vw;\n      padding: 0.555vw 1.11vw;\n      background: #e2e2e2bf;\n      border-radius: 2.02px, 0px, 0px, 2.02px;\n    }\n\n    .game-detail {\n      padding: 2.5vw 2.22vw;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n\n      .game-title {\n        font-size: 0.91vw;\n        line-height: 1.25vw;\n        font-weight: 500;\n        color: #0f0f0f;\n      }\n      & > div {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        justify-content: space-between;\n      }\n\n      .game-description {\n        font-size: 0.835vw;\n        line-height: 1.25vw;\n        margin-top: 0.555vw;\n        font-weight: 400;\n        color: #3a3a3a;\n      }\n\n      .customize {\n        font-size: 0.901875vw;\n        font-weight: 600;\n        line-height: 1.25vw;\n        letter-spacing: 0em;\n        text-align: center;\n        border-radius: 0.21vw;\n        border: none;\n        transition: 0.2s ease-in-out all;\n        cursor: pointer;\n        color: #ffffff;\n        background: #ee3a24;\n        padding: 0.8325vw 2.22vw;\n        width: max-content;\n        margin: 0.8325vw 0 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        span {\n          position: relative;\n          padding: 0;\n          top: 0.14vw;\n          margin: 0 1.11vw;\n        }\n      }\n    }\n  }\n\n  .videoPopup {\n    width: 100vw;\n    height: 100vh;\n    position: absolute;\n    top: 0;\n\n    .video {\n      justify-content: center;\n    }\n  }\n}\n\n.trigger_limit select, .is_active select {\n  border: 1px solid #bebaba !important;\n}\n\n.trigger_limit select:focus, .is_active select:focus {\n  border: 1px solid #ee3a24cc !important;\n}\n\n.trigger_limit select, .is_active select {\n  width: 100%;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.trigger_limit select#triggerTime,\n.trigger_limit select#trigger_limit,\n.is_active select#is_active,\n.is_active select#is_active  {\n  background: url(\"../../../assets/svg/select-arrow.svg\") no-repeat;\n  background-color: #fff;\n}\n\n.trigger_limit select#triggerTime,\n.trigger_limit select#trigger_limit,\n.is_active select#is_active,\n.is_active select#is_active {\n  background-size: 0.754rem;\n  background-position: calc(100% - 0.555vw) 1.38vw;\n  background-repeat: no-repeat;\n}\n\n.trigger_limit select,\n.is_active select,\n.coupon_code input,\n.add-question input,\n.Options input {\n  width: 100%;\n  font-weight: 400;\n  line-height: 1.25vw;\n  font-size: 0.901875vw;\n  color: #616161;\n  -ms-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border-radius: 0.21vw;\n  padding: 0.8325vw 0.555vw;\n}\n\n.coupon_code .MuiFormControl-root {\n  margin: 0 !important;\n  border: none;\n  box-shadow: none;\n  border-radius: 3px;\n  color: #d9d9d900;\n}\n\n.coupon_code .MuiInputBase-root {\n  color: #d9d9d900;\n  box-shadow: none;\n  padding: 0.6vw 0.555vw;\n}\n\n.coupon_code .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,\n.coupon_code .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {\n  border: 1px solid #ababab;\n}\n\n.coupon-quiz-input {\n  margin: 0.7vw 0;\n  width: 100%;\n  border-radius: 3px;\n}\n\n.coupon_code {\n  position: relative;\n}\n\n.plus-icon {\n  position: absolute;\n  right: 1.3875vw;\n}\n\n.select-gamification {\n  font-size: 0.91vw;\n  line-height: 1.25vw;\n  font-weight: 500;\n  color: #616161;\n  cursor: pointer;\n}\n\n.ques-subheading {\n  font-size: 1.05vw !important;\n  color: #ee3a24;\n  font-weight: 500 !important;\n  line-height: 1.25vw !important;\n  margin-top: 0.15vw !important;\n}\n\n.add-ques-text {\n  font-size: 1.05vw !important;\n  font-weight: 500 !important;\n  line-height: 1.25vw !important;\n  color: #3a3a3a !important;\n}\n\n.quiz-container .MuiFormControlLabel-label {\n  font-size: 0.91vw !important;\n  font-weight: 400 !important;\n  line-height: 1.25vw !important;\n  color: #ababab !important;\n}\n\n.trigger-time, .is_active {\n  font-size: 1.05vw !important;\n  line-height: 1.25vw !important;\n  font-weight: 500 !important;\n}\n\n.trigger_limit label,\n.is_active label,\n.coupon_code label {\n  font-size: 1.05vw;\n  font-weight: 500;\n  width: 100%;\n  line-height: 1.25vw;\n  color: #3a3a3a;\n}\n\n.add-question label,\n.Options label {\n  font-size: 1.05vw;\n  font-weight: 500;\n  width: 30%;\n  line-height: 1.25vw;\n  color: #3a3a3a;\n}\n\n.Options {\n  position: relative;\n}\n\n.Options input {\n  position: relative;\n  left: 3.13vw;\n}\n\n.correct-ans {\n  width: 33%;\n  margin-left: 3.82vw;\n  font-size: 0.8325vw;\n  font-weight: 400;\n  line-height: 1.25vw;\n  color: #ababab;\n}\n\n.correct-ans-box {\n  width: 1.05vw;\n  height: 0.7vw;\n  border-radius: 50%;\n  border: 1px solid #ababab;\n}\n\n.correct-ans.active {\n  color: #b01f8d;\n}\n\n.correct-ans-box.active {\n  width: 1.25vw;\n  height: 0.7vw;\n  border-radius: 50%;\n  background-color: #b01f8d;\n  border: none;\n}\n\n.trigger_limit {\n  margin-top: 1.11vw;\n}\n\n.trigger_limit,\n.is_active,\n.coupon_code,\n.add-question,\n.Options {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n  padding: 0.555vw 0;\n}\n\n.spin-wheel-game-container,\n.quiz_coupon_code_container {\n  width: 58.24vw;\n  margin: auto;\n  .MuiFormHelperText-root.Mui-error {\n    font-size: 11px;\n    margin: 0.25rem;\n    color: #ee3a24cc !important;\n  }\n}\n\n.select-gamification {\n  display: flex;\n  align-items: center;\n}\n\n.spin-wheel-submit {\n  text-align: center;\n}\n\n.spin-wheel-submit button {\n  background-color: #ee3a24;\n  border-radius: 0.21vw;\n  padding: 1.11vw 4.44vw;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n}\n\n.inner-quiz-game-container {\n  form {\n    margin: auto;\n    width: 47.94vw;\n  }\n}\n\n.inner-game-container {\n  form {\n    margin: auto;\n    width: 29.21vw;\n  }\n}\n\n.submit-quiz {\n  text-align: center;\n}\n\n.quiz-tb-container {\n  align-items: center !important;\n  display: flex !important;\n  justify-content: center;\n}\n\n.prev-submit-quiz {\n  margin-left: 0.35vw !important;\n  margin-right: 0.7vw !important;\n  background-color: #fff;\n  border-radius: 0.21vw !important;\n  padding: 0.555vw 2.22vw !important;\n  border: 1px solid #ee3a24 !important;\n  color: #ee3a24 !important;\n  cursor: pointer !important;\n  align-items: center !important;\n  display: flex !important;\n}\n\n.submit-quiz {\n  margin-left: 0.35vw !important;\n  margin-right: 0.7vw !important;\n  background-color: #ee3a24 !important;\n  border-radius: 0.21vw !important;\n  padding: 0.555vw 2.22vw !important;\n  border: none !important;\n  color: #fff !important;\n  cursor: pointer !important;\n  align-items: center !important;\n  display: flex !important;\n}\n.MuiInputBase-root.Mui-error fieldset.MuiOutlinedInput-notchedOutline {\n  border: 1px solid #ee3a24cc;\n}\n.gamification .game-list .game-detail .customize:disabled,\n.button2:disabled,\n.button2[disabled] {\n  background: #dcdcdc !important;\n  color: #939393 !important;\n  border: aliceblue;\n  cursor: unset;\n}\n.gamification .game-list .game-detail .customize:disabled svg path,\n.button2:disabled svg path,\n.button2[disabled] svg path {\n  fill: #939393 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
